import React, { useEffect, useState, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from "../../../redux/modalSlice";
import { useForm, Controller } from 'react-hook-form'
import { useRequest } from '../../../hooks/UseRequest'
import { setNotification } from '../../../redux/notificationSlice'
import { triggerRerender } from '../../../redux/rerenderSlice'

export default function CustomerSsnModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  const { handleSubmit, control, formState: { errors }, reset } = useForm();
  const [saving, setSaving] = useState(false)
  const request = useRequest()
  const customerId = modal.options?.customerId
  const navi = useNavigate()
  const inputSsn = useRef(null);

  useEffect(() => {
    if (modal.type === 'customer_ssn_modal' && modal.is_active) {
      inputSsn.current.focus()
    }
  }, [modal]);

  const onSubmit = async (formData) => {
    setSaving(true)
    request.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/customer/${customerId}/ssn`)
    try {
      const response = await request.modify(formData)
      if (response.status === 200 || response.status === 201) {
        setSaving(false)
        handleCancel()
        dispatch(setNotification({ type: 'success', body: '' }))
        const pathSegments = window.location.pathname.split('/');
        const moduleName = pathSegments[1];
        if (moduleName === 'manual_verification') {
          dispatch(triggerRerender({ subpanelId: 'manual_verification' }));
        } else {
          navi(`/${moduleName}/${customerId}`, { state: { reloadPage: true } });
        }
      } else {
        setSaving(false)
        dispatch(setNotification({ type: 'error', body: `Error: ${response.status}` }))
      }
    } catch (error) {
      setSaving(false)
      const errorMessage = error?.response?.data?.message ?? error?.response?.data?.messageExtreme
      dispatch(setNotification({ type: 'error', body: errorMessage }))
    }
  }

  const handleCancel = () => {
    dispatch(setModal({ is_active: false }));
    reset();
  };

  return modal.is_active && modal.type === 'customer_ssn_modal' ? (
    <form onSubmit={handleSubmit(onSubmit)} id="customer_ssn_modal_form" className="lox-form">
      <div className="modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card column is-3">
          <header className="modal-card-head py-3">
            <p className="modal-card-title is-capitalized">
              Update Social Security Number
            </p>
            <button className="delete" aria-label="close" onClick={handleCancel}></button>
          </header>
          <section
            className="modal-card-body modal-card-body pt-1 pb-1"
            style={{ minHeight: "100px", overflow: 'hidden' }}
          >
            <div className="columns mb-0 is-flex-direction-column mt-3">
              <div className="column">
                <div className="field">
                  <label htmlFor="social_security_number">
                   Social Security Number
                    <span className="has-text-danger">*</span>
                  </label>
                  <Controller
                    name="ssn"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <input {...field} type="text" id="ssn" className="input is-small" ref={inputSsn} />
                    )}
                  />
                   <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                     {errors.ssn && <span>{errors.ssn.message ? errors.ssn.message : "Social Security Number is required"}</span>}
                   </p>
                </div>
              </div>
            </div>
          </section>
          <footer className="modal-card-foot is-justify-content-end py-1">
            <div className="lox-form__buttons-wrapper has-text-right">
              <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleCancel}>Cancel</button>
              <button type="submit" className="button is-link is-small" disabled={saving && 'disabled'}>{saving ? 'Saving' : 'Save'}</button>
            </div>
          </footer>
        </div>
      </div>
    </form>
  ) : null;
}
